const ConditionalRendering = ({ condition, children }) => {
  return !!condition ? children : null;
};

export default ConditionalRendering;
